var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppHeader'),_c('v-main',{style:({ margin: `0 ${_vm.marginStyle}px`, overflow: 'auto' })},[_c('router-view')],1),_c('Dialogs'),_c('Messages',{attrs:{"styles":{ top: 0, left: 'calc( 50% - 200px )', width: '400px' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }